
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

interface MenuButtonProps {
  onClick: () => void;
}

export const MenuButton = ({ onClick }: MenuButtonProps) => {
  return (
    <div className="fixed top-4 left-4 z-50">
      <Button 
        variant="ghost" 
        size="icon"
        onClick={onClick}
        className="bg-white/70 backdrop-blur-sm"
      >
        <Menu className="h-6 w-6 text-[#004080]" />
      </Button>
    </div>
  );
};
